/**
 * For project-specific messages/translations, these are the keys in the key-value pairs for a given language.
 */
export enum ProjStr {
  ConfidentialityMessageTitle           = 'Portal-ConfidentialityMessageTitle',
  ConfidentialityMessageAgreement       = 'Portal-ConfidentialityMessageAgreement',
  ConfidentialityMessageAcknowledgement = 'Portal-ConfidentialityMessageAcknowledgement',
  ConfidentialityMessageFooter          = 'Portal-ConfidentialityMessageFooter',

  AddToSurvey                           = 'Portal-AddToSurvey',
  CreateSurveyMsg                       = 'Portal-CreateSurveyMsg',
  CreateSurveyMinMaxMsg                 = 'Portal-CreateSurveyMinMaxMsg',
  CreateSurveyMinMsg                    = 'Portal-CreateSurveyMinMsg',
  CreateSurveyMaxMsg                    = 'Portal-CreateSurveyMaxMsg',
  CreateSurveyReadyMsg                  = 'Portal-CreateSurveyReadyMsg',
  CreateSurveyMaxErrMsg                 = 'Portal-CreateSurveyMaxErrMsg',
  NoSurveyItemsAdded                    = 'Portal-NoSurveyItemsAdded',
  RequiredForSurvey                     = 'Portal-RequiredForSurvey',

  DevPlanInstructions                   = 'Portal-DevPlanInstructions',
  SetGoalsIntro                         = 'Portal-SetGoalsIntro',
  InviteRatersIntro                     = 'Portal-InviteRatersIntro',
}
